import { useCallback } from 'react'

import { useLazyGetGiftsForManyProductsQuery, useLazyGetProductGiftsQuery } from '../api/cart-api-slice'
import { Gift } from '../types/gifts'

type GiftResponsePackages = {
	one?: Gift[]
	allPackages?: Gift[][]
	all?: Gift[][]
}

type Product = {
	PRODUCT_ID: number
	QUANTITY: number
}

export const useProductGifts = () => {
	const [checkProductGifts, giftsForOneProductResult] = useLazyGetProductGiftsQuery()
	const [checkProductsGifts, giftsForManyProductsResult] = useLazyGetGiftsForManyProductsQuery()

	const checkOneProductForGifts = useCallback(
		async (productId: number): Promise<GiftResponsePackages> => {
			try {
				const productGifts = (await checkProductGifts({ productId }).unwrap()) as any
				const one: Gift[] = Array.isArray(productGifts?.one) ? productGifts.one : []
				const allPackages: Gift[][] = Array.isArray(productGifts?.all) ? (productGifts.all as Gift[][]) : []
				return { one, allPackages }
			} catch (error) {
				return {
					one: [],
					allPackages: []
				}
			}
		},
		[checkProductGifts]
	)

	const checkManyProductsForGifts = useCallback(
		async (products: Product[]): Promise<GiftResponsePackages> => {
			if (!products.length) {
				return { one: [], allPackages: [] }
			}
			try {
				const productsGifts = (await checkProductsGifts({ products }).unwrap()) as any
				const one: Gift[] = Array.isArray(productsGifts?.one) ? productsGifts.one : []
				const allPackages: Gift[][] = Array.isArray(productsGifts?.all) ? (productsGifts.all as Gift[][]) : []
				return { one, allPackages }
			} catch (error) {
				return {
					one: [],
					allPackages: []
				}
			}
		},
		[checkProductsGifts]
	)

	return {
		checkOneProductForGifts,
		checkManyProductsForGifts,
		//
		giftsForOneProductResult,
		giftsForManyProductsResult
	}
}
